export default {
  // 获取历史聊天记录
  getChatHistory: '/api/v1/chat/getChatHistory',
  // 连接客服
  userConnectService: '/api/chat/userConnectService',
  // 结束客服
  userDisConnectService: '/api/chat/userDisConnectService',
  // 发送消息
  sendMessage: '/api/chat/sendMessage',
  // 获取最新的会话和历史聊天记录
  getLastChatHistory: '/api/chat/getLastChatHistory',
  // 获取最新的会话和历史聊天记录
  saveMessage: '/api/chat/saveMessage',
  // 保存首次会话
  saveFirstChat: '/api/v1/chat/saveFirstChat',
}
